import { useEffect } from 'react'

import useAhoy from '~/hooks/useAhoy'

export default function useViewContactMeta(data) {
  const ahoy = useAhoy()
  useEffect(() => {
    if (ahoy) {
      ahoy.track('view_dealer_page', {
        seller_id: data.id
      })
    }
  }, [ahoy])
}
